export default "__VITE_ASSET__4ZJJ9Pgv__"